import moment from 'moment'
import {FormattedMessage, useIntl} from 'react-intl'
import {EdgeMemberPolicy} from '../../../types/policiesApi'
import {PhoneProviderActions} from '../../../components/telephony/PhoneProviderActions'

const bullet = '•'
const sp = ' '

interface IHolderProps {
  members: EdgeMemberPolicy[]
  memberId?: string
  zipCode?: string | null
  stateName?: string | null
  stateCode?: string | null
  countyFips?: string | null
}

export const HolderInfoSide = ({
  members,
  memberId,
  zipCode,
  stateName,
  stateCode,
  countyFips,
}: IHolderProps) => {
  const intl = useIntl()
  const nr = intl.formatMessage({id: 'policies.list.preview.value.nr', defaultMessage: 'N/R'})
  const findHolder = members.find(({node}) => node.rol === 'HOLDER')

  if (!findHolder) {
    return (
      <div className='kt-widget__info d-flex flex-center' style={{height: '120px'}}>
        <span className='kt-widget__label'>
          <FormattedMessage
            id='policies.detail.holder.noOwner'
            defaultMessage='There is no information about the owner yet'
          />
        </span>
      </div>
    )
  }

  const {node} = findHolder

  // Calculate totalIncome from up to 3 annualIncome fields
  /*const totalIncome = incomeFields.reduce((sum, val) => {
    const parsed = typeof val === 'string' ? parseFloat(val.replace(/,/g, '')) : parseFloat(val)
    return !isNaN(parsed) && parsed > 0 ? sum + parsed : sum
  }, 0)*/

  // Calcular totalIncome de todos los miembros, no solo el holder
  const totalIncome = members.reduce((sum, {node}) => {
    const incomes = [node.annualIncome1, node.annualIncome2, node.annualIncome3]
    return (
      sum +
      incomes.reduce((innerSum, val) => {
        const parsed =
          typeof val === 'string' ? parseFloat(val.replace(/,/g, '')) : parseFloat(val)
        return !isNaN(parsed) && parsed > 0 ? innerSum + parsed : innerSum
      }, 0)
    )
  }, 0)

  return (
    <>
      <div className='kt-heading kt-heading--sm custom-border-brand my-3'>
        <FormattedMessage id='policies.detail.holder.title' defaultMessage='Holder Information' />
      </div>
      <div className='kt-widget__info'>
        <span className='kt-widget__label'>
          <FormattedMessage id='policies.detail.holder.holder' defaultMessage='Holder:' />
        </span>
        <span className='kt-widget__data'>
          {node.firstName} {node.lastName}
        </span>
      </div>
      <div className='kt-widget__info'>
        <span className='kt-widget__label'>
          <FormattedMessage id='policies.detail.holder.dateOfBirth' defaultMessage='Date of birth:' />
        </span>
        <span className='kt-widget__data'>
          {sp}
          {node.dateBirth ? moment(node.dateBirth).format('MM/DD/YYYY') : nr}
        </span>
      </div>
      <div className='kt-widget__info'>
        <span className='kt-widget__label'>
          <FormattedMessage id='policies.list.preview.table.ssn' defaultMessage='SSN' />
        </span>
        <span className='kt-widget__data'>{node.ssn || nr}</span>
      </div>
      <div className='kt-widget__info'>
        <span className='kt-widget__label'>
          <FormattedMessage id='common.field.phone' defaultMessage='Phone' />
        </span>
        <div className='kt-widget__data'>
          <PhoneProviderActions phone={node.phone} />
        </div>
      </div>
      <div className='kt-widget__info'>
        <span className='kt-widget__label'>
          <FormattedMessage id='policies.detail.holder.location' defaultMessage='Location' />
        </span>
        <span className='kt-widget__data'>
          {zipCode || stateName || stateCode || countyFips ? (
            <>
              {zipCode || nr} {bullet}{sp}
              {stateName ? `${stateName}${stateCode ? ` (${stateCode})` : ''}` : nr} {bullet}{sp}
              {countyFips || nr}
            </>
          ) : (
            nr
          )}
        </span>
      </div>
      <div className='kt-widget__info'>
        <span className='kt-widget__label'>
          <FormattedMessage
            id='policies.detail.form.member.employment.annualIncome'
            defaultMessage='Annual income'
          />
        </span>
        <span className='kt-widget__data' id='household_income_label'>
          {totalIncome > 0 ? totalIncome.toLocaleString('en-US') : nr}
        </span>
      </div>
      <div className='kt-widget__info'>
        <span className='kt-widget__label'>
          <FormattedMessage id='policies.detail.holder.memberId' defaultMessage='Member ID:' />
        </span>
        <span className='kt-widget__data'>{memberId || nr}</span>
      </div>
    </>
  )
}
